import Path751x from '../../assets/img/path-75@1x.png';
import IconMetroFacebook1xPng1x from '../../assets/img/icon-metro-facebook-1x-png@1x.png';
import IconAwesomeTwitterSquare1x from '../../assets/img/icon-awesome-twitter-square@1x.png';
import IconAwesomeLinkedin1x from '../../assets/img/icon-awesome-linkedin@1x.png';
import './index.css';
import './responsive.css';

function FooterSection() {
  return (
    <div className="pos_-footer-osl3uq">
    <div className="group-1234-BJUnr5">
      <div className="rectangle-292-ikLsNp"></div>

      <div className="top-container">
        <div className="col-left">
          <div className="agency-ikLsNp bentonsanscond-regular-normal-white-21px" onClick={() => { window.location.href= "https://mblm.com/" }}>Agency</div>
          <div className="lab-ikLsNp bentonsanscond-regular-normal-white-21px" onClick={() => { window.location.href= "https://mblm.com/lab" }}>Lab</div>
          <div className="platform-ikLsNp bentonsanscond-regular-normal-white-21px" onClick={() => { window.location.href= "https://mblm.com/platform" }}>Platform</div>
        </div>

        <div className="col-right">
          <span>
            <img className="path-75-ikLsNp" src={Path751x} />
            
            <div className="social-icons-mobile">
              <img className="icon-metro-facebook-ikLsNp" src={IconMetroFacebook1xPng1x} onClick={() => { window.location.href= "https://www.facebook.com/mblm.friends/?ref=bookmarks" }} />
              <img className="icon-awesome-twitter-square-ikLsNp" src={IconAwesomeTwitterSquare1x} onClick={() => { window.location.href= "https://twitter.com/mblm" }} />
              <img className="icon-awesome-linkedin-ikLsNp" src={IconAwesomeLinkedin1x} onClick={() => { window.location.href= "https://www.linkedin.com/company/68125/" }} />
            </div>
          </span>
        </div>
      </div>

      <div className="bottom-container">
        <div className="col-left">
          <div className="social-icons">
            <img className="icon-metro-facebook-ikLsNp" src={IconMetroFacebook1xPng1x} onClick={() => { window.location.href= "https://www.facebook.com/mblm.friends/?ref=bookmarks" }} />
            <img className="icon-awesome-twitter-square-ikLsNp" src={IconAwesomeTwitterSquare1x} onClick={() => { window.location.href= "https://twitter.com/mblm" }} />
            <img className="icon-awesome-linkedin-ikLsNp" src={IconAwesomeLinkedin1x} onClick={() => { window.location.href= "https://www.linkedin.com/company/68125/" }} />
          </div>

          <div className="contact-us-ikLsNp bentonsanscond-regular-normal-white-17px" onClick={() => { window.location.href= "https://mblm.com/contact/" }}>Contact Us</div>
        </div>

        <div className="col-right">
          <span className="footer-links">
            <div className="privacy-policy-ikLsNp bentonsanscond-regular-normal-white-11px" onClick={() => { window.location.href= "https://mblm.com/privacy-policy/" }}>PRIVACY POLICY</div>
            <div className="all-rights-reserved-ikLsNp bentonsanscond-regular-normal-white-11px">ALL RIGHTS RESERVED</div>
            <div className="emblem2022-ikLsNp bentonsanscond-regular-normal-white-11px">EMBLEM LLC 2022</div>
          </span>
        </div>
      </div>
    </div>
  </div>
  )
}

export default FooterSection;